import {
    NAV_ITEM_TYPE_TITLE,
    NAV_ITEM_TYPE_ITEM,
} from 'constants/navigation.constant'

const baseNavigationConfig = [
    {
        key: 'pokemon',
        path: '',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        authority: [],
        subMenu: [],
    },
];

function filterPokemon(pokemonSubMenuItems, searchTerm) {
    return pokemonSubMenuItems.filter((pokemon) =>
      pokemon.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
}

function pokemonNavConfig({ pokemonData, searchTerm }) {
    try {
      if (!Array.isArray(pokemonData)) {
        throw new Error('Pokemon data is not an array');
      }
  
      // Map the fetched data to submenu items
      const pokemonSubMenuItems = pokemonData.map((pokemon, index) => ({
        key: `pokemon.pokemon${index + 1}`,
        path: `/pokemon/${pokemon.id}`,
        title: pokemon.name,
        translateKey: pokemon.name,
        icon: pokemon.id,
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      }));

      const filteredPokemonSubMenuItems = filterPokemon(
        pokemonSubMenuItems,
        searchTerm
      ).slice(0,100);
  
      // Clone the baseNavigationConfig to avoid modifying it directly
      const updatedNavigationConfig = [...baseNavigationConfig];
  
      // Find the "statistics" submenu in updatedNavigationConfig
      const statisticsSubMenuIndex = updatedNavigationConfig.findIndex(
        (item) => item.key === 'pokemon'
      );
  
      if (statisticsSubMenuIndex !== -1) {
        // If "statistics" submenu is found, update its "pokemon" subMenu
        updatedNavigationConfig[statisticsSubMenuIndex].subMenu = filteredPokemonSubMenuItems;
      }
  
      return updatedNavigationConfig;
    } catch (error) {
      console.error('Error updating Pokemon submenu:', error);
      return baseNavigationConfig;
    }
}
    

export default pokemonNavConfig
